module.exports = __webpack_public_path__ + "static/media/wa-logo.wine.ba90dc77.svg";